/**
 * The editor dock's API surface: template placeholders.
 *
 * The assistant is zehn-aip's panel, framed in the dock
 * (components/AipPanelFrame.jsx).
 * These paths go through the app's axios client (`useLoad` / `usePutRequest`
 * from shared/hooks/requests.js, docs' session cookie) like every other docs
 * call; each names the file by its uuid.
 */

import { TEMPLATE_PLACEHOLDERS } from '@/shared/utils/urls.js';

// Template placeholders: definitions on a template, filled values on a
// document created from it. Values travel as [{key, value}] LISTS — humps
// would camelize a slug-keyed object.
export const FILE_PLACEHOLDERS = TEMPLATE_PLACEHOLDERS;
export const FILE_PLACEHOLDER_VALUES = '/embed/v1/file/{file_uuid}/placeholders/values';
export const FILE_PLACEHOLDER_PLACEMENTS = '/embed/v1/file/{file_uuid}/placeholders/placements';

/** `route` for the file `fileUuid`. */
export const forFile = (route, fileUuid) => route.replace('{file_uuid}', encodeURIComponent(String(fileUuid)));
